import { z } from "zod";
import { expenseCategories } from "@/server/platform/db/schema/expenses";

export { expenseCategories };

export const IdParamSchema = z.object({ id: z.string().min(1) });

export const ExpenseCategorySchema = z.enum(expenseCategories);
export type ExpenseCategoryDTO = z.infer<typeof ExpenseCategorySchema>;

export const ExpenseInputSchema = z.object({
  category: ExpenseCategorySchema,
  amount: z.coerce.number().positive(),
  spentAt: z.string().min(1),
  title: z.string().min(1).max(200),
  vendor: z.string().max(200).optional().nullable(),
  platform: z.string().max(80).optional().nullable(),
  campaignName: z.string().max(200).optional().nullable(),
  mappedProductId: z.string().max(200).optional().nullable(),
  mappedCategoryId: z.string().max(200).optional().nullable(),
  linkedOrderId: z.string().max(200).optional().nullable(),
  note: z.string().max(1000).optional().nullable(),
});

export const CreateExpenseSchema = ExpenseInputSchema;
export type CreateExpenseDTO = z.infer<typeof CreateExpenseSchema>;

export const UpdateExpenseSchema = ExpenseInputSchema.partial();
export type UpdateExpenseDTO = z.infer<typeof UpdateExpenseSchema>;

export const ExpenseListQuerySchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  category: ExpenseCategorySchema.optional(),
  platform: z.string().optional(),
  campaignName: z.string().optional(),
  mappedProductId: z.string().optional(),
  mappedCategoryId: z.string().optional(),
  search: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional().default(20),
  offset: z.coerce.number().int().min(0).optional().default(0),
});
export type ExpenseListQueryDTO = z.infer<typeof ExpenseListQuerySchema>;

export const ExpenseSummaryQuerySchema = z.object({
  from: z.string().min(1),
  to: z.string().min(1),
  platform: z.string().optional(),
  campaignName: z.string().optional(),
  mappedProductId: z.string().optional(),
  mappedCategoryId: z.string().optional(),
});
export type ExpenseSummaryQueryDTO = z.infer<typeof ExpenseSummaryQuerySchema>;
